import { GITHUB_PROFILE_URL, GITHUB_USERNAME } from '../constants/branding';

export function LoginCredit({ labels }) {
  return (
    <div className="relative z-10 mt-3 w-full max-w-md px-2 text-center">
      <p className="inline-flex items-center rounded-full bg-card/80 px-3 py-1 text-xs text-muted shadow-card backdrop-blur-sm dark:bg-card/70">
        <span>{labels.loginCreditBy} </span>
        <a
          href={GITHUB_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-primary hover:underline"
          aria-label={`${labels.loginCreditBy} GitHub @${GITHUB_USERNAME}`}
        >
          @{GITHUB_USERNAME}
        </a>
      </p>
    </div>
  );
}

